import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Box from '@mui/material/Box'
import './Work.css';
import kratinportal from '../../Assets/Work/kratinportal-in.png';
import period from '../../Assets/period.svg';
import {Link} from 'react-router-dom';
import post1 from '../../Assets/Work/post1.png';
import post2 from '../../Assets/Work/post2.png';
import post3 from '../../Assets/Work/post3.png';
import post4 from '../../Assets/Work/post4.png';
import post5 from '../../Assets/Work/post5.png';
import Carousel from 'react-bootstrap/Carousel';
import NavBar from "../Navbar";
import Footer from "../Footer";

function KratinSM() {
  return (
    <section>
      <NavBar />
      <Box className="filebox">

            <Row>
            <aside>
              <Col sm={1}>
                <Container style={{ height: '100%' }}>
            
            <div direction="right" className="side-banner">
            <div className="marquee">
              <div className="marquee-content" style={{animationDuration: '100s' }}>Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding         Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding         Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding         Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding         Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding         Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          Kratin Branding          
              </div>
              </div>
              </div>
                </Container>
              </Col>
              <Col sm={10} className="canteen-ui" style={{ paddingLeft: '130px', paddingRight: '70px' }}>
              <Container fluid className="project-section">
          <Container  className="canteen-content">
                <Row className="first-img" style={{ justifyContent: "center", paddingTop: '40px', paddingBottom: "40px" }}>

                <img
                      src={kratinportal}
                      alt="Kratin Branding"
                      className="img-fluid"
                      style={{ padding: '0px'}}
                    />
                  </Row>
                  <Row style={{paddingBottom: "40px"}}>
                  <div style={{display:'flex'}}>
                  <h1>Social Media & Brand Awareness
                  <img
                    src={period}
                    alt="period"
                    className="img-fluid"
                    style={{marginLeft: '2px', paddingTop: '2.5%' }}
                  />
                  </h1>
                  
                  </div>
                  <p className="content">Kratin maintains an everlasting presence on social media, which allows them to attract potential clients by sharing product-related content and industry-related infographics. 

</p>
                </Row>
                <Row style={{paddingBottom: "56px", fontFamily: 'Changa', fontSize: '1.2em'}} >
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">MY ROLE</p>
                    <p className="box-p">Visual Design Intern</p>
                    </div>
                    </Col>
                    
                    
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TIMELINE</p>
                    <p className="box-p">October, 2021 - Ongoing</p>
                    </div>
                    </Col>
                    <Col sm={4} className="box-col">
                    <div style={{border: "1px solid white", padding: '5%', height: '100%' }}>
                    <p className="box-head">TOOLS USED</p>
                    <p className="box-p">Figma, PhotoShop, Canva</p>
                    </div>
                    </Col>
                </Row>

                <Row style={{paddingBottom: "32px"}}>
                    <Col>
                    <hr></hr>
                    <div style={{display: 'flex'}}>
                    <h2>TOP PERFORMING POSTS 
                    <img
                      src={period}
                      alt="period"
                      className="img-fluid top-posts"
                      style={{ paddingLeft:'2px', paddingTop: '2.5%'}}
                    /> </h2>
                    
                    </div>
                    <Carousel  slide={false} className="carousel" style={{verticalAlign: 'center'}}>
                      <Carousel.Item >
                        <img
                          className="d-block w-100"
                          src={post1}
                          alt="First slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={post3}
                          alt="Second slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={post5}
                          alt="Third slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={post4}
                          alt="Fourth slide"
                        />
                      </Carousel.Item>
                      <Carousel.Item>
                        <img
                          className="d-block w-100"
                          src={post2}
                          alt="Last slide"
                        />
                      </Carousel.Item>
                
                </Carousel>
                    
                    </Col>
                </Row>
                <Row style={{marginBottom: "100px", paddingTop:"64px", fontFamily: 'Changa', fontSize: '1.2em'}}>
                  <Link to={'/experience/kratinportal'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute'}}>
                    Previous
                    </div>
                  </Link>
                  <Link to={'/experience/monalis'} style={{textDecoration: 'none'}}>
                    <div className="button-work" style={{border: "1px solid white",borderRadius:'5px', height: 'auto', width: '15%',color:'white', textAlign: 'center', verticalAlign: 'center', paddingTop: '10px', paddingBottom:'10px', position: 'absolute', right:'0px'}}>
                    Next
                    </div>
                  </Link>
                </Row>     
                
            </Container>
                </Container>
              </Col>
              </aside>
            </Row>
            
        <Footer />
      </Box>
    </section>
  );
}

export default KratinSM;
